export const environment = {
  API_URL:'https://api.reconease.ai/',
  RAZORPAY_KEY: 'rzp_live_3631saYeO6ynSW'
};
